const Legal = () =>
  import(/* webpackChunkName: "user-legal" */ '@/pages/user/legal')

const CreateLegal = () =>
  import(/* webpackChunkName: "user-legal" */ '@/pages/user/legal/create.vue')
const EditLegal = () =>
  import(/* webpackChunkName: "user-legal" */ '@/pages/user/legal/edit.vue')

export default {
  path: 'legal',
  meta: {
    label: 'legal',
    auth: 'legal'
  },
  component: {
    name: 'Legal',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'UserLegalReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Legal
    },
    {
      name: 'UserCreateLegal',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateLegal
    },
    {
      name: 'UserEditLegal',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditLegal,
      props: true
    }
  ]
}
